export default __webpack_public_path__ + "static/jira-product-discovery_attribution_light-c013a4427321b430c6ff0bef0ff118d43096741f1601cb5c3eab671b7ac39fd7.svg";